import { orchestrator } from 'satcheljs';
import { getPrimaryAndConnectedAccountsSmtpAddresses } from 'owa-session-store';
import {
    loadWorkloadScenarioSettings,
    workloadScenarioSettingsLoaded,
    loadingWorkloadScenarioSettingsFailed,
} from '../actions/publicActions';
import { getWorkloadScenarioSettings } from '../services/getWorkloadScenarioSettingsService';
import { createRetriableFunction, createExponentialBackoffFuntion } from 'owa-retriable-function';
import { Settings } from '../schema/ScenarioSettings';

const createRetriableFunc = createRetriableFunction({
    maximumAttempts: 3,
    timeBetweenRetryInMS: createExponentialBackoffFuntion(10000),
});
let currentRequest: { retriableFunc: () => Promise<Settings>; cancel: () => void } = null;

export const loadWorkloadScenarioSettingsOrchestrator = orchestrator(
    loadWorkloadScenarioSettings,
    async () => {
        getPrimaryAndConnectedAccountsSmtpAddresses().forEach(loadSettings);
    }
);

export async function loadSettings(accountSmtpAddress: string) {
    let settings: Settings;
    try {
        // if there is a request out to get settings, cancel it
        if (currentRequest) {
            currentRequest.cancel();
        }
        currentRequest = createRetriableFunc(() => getWorkloadScenarioSettings(accountSmtpAddress));
        settings = await currentRequest.retriableFunc();
        workloadScenarioSettingsLoaded(settings, accountSmtpAddress);
    } catch {
        loadingWorkloadScenarioSettingsFailed(accountSmtpAddress);
    }
    currentRequest = null;
}
